import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  TextField,
  Divider,
} from '@mui/material';
import React from 'react';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { playbackDateAtom } from 'atoms';
import dayjs from 'dayjs';

function PlaybackDateTimeModal({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { t } = useTranslation(['cameras', '_common']);
  const setPlaybackDate = useSetRecoilState(playbackDateAtom);
  const [playbackDateInternal, setPlaybackDateInternal] = React.useState<string | null>(null);

  function confirmDate() {
    setPlaybackDate(playbackDateInternal);
    setOpen(false);
  }

  return (
    <Dialog {...{ open }} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>{t('cameras:select_the_date_and_time_to_playback')}</DialogTitle>
      <DialogContent>
        <DesktopDateTimePicker
          inputFormat="L LT"
          value={playbackDateInternal}
          // @ts-ignore
          maxDateTime={dayjs()}
          onChange={(newDate: Date | null) => {
            newDate &&
              // @ts-ignore
              !isNaN(newDate) &&
              setPlaybackDateInternal(dayjs(newDate).format());
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              inputProps={{
                ...params.inputProps,
                placeholder: `${dayjs().localeData().longDateFormat('L')} ${dayjs()
                  .localeData()
                  .longDateFormat('LT')}`,
              }}
            />
          )}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={() => setOpen(false)}>{t('_common:close')}</Button>
        <Button variant="contained" onClick={confirmDate}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PlaybackDateTimeModal;
